export default "__VITE_ASSET__BcrgSbLd__"